import { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { TextResponsePanel } from "../../pages/tabs/loonopzand/MultiChoiceWithTextPanel";
import "../../pages/LoonOpZandDashboard.css";
import "./CeoTextAnswers.css";

export function CeoTextPanel({ title, items = [], onPage = false }) {
  const availableIssues = useMemo(
    () => [...new Set(items.map((item) => item.issue))]
      .sort()
      .map((value) => ({ value, label: value })),
    [items]
  );

  return (
    <div className={onPage ? "ceo-text-answers ceo-text-answers--page" : "ceo-text-answers"}>
      <TextResponsePanel
        question={{ text: title, items }}
        availableIssues={availableIssues}
        title={title}
        standalone={onPage}
      />
    </div>
  );
}

export function CeoTextModalButton({ title, items = [], label = "Bekijk tekstantwoorden" }) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const closeRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    const trigger = triggerRef.current;
    closeRef.current?.focus();
    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
      if (event.key === "Tab") {
        event.preventDefault();
        closeRef.current?.focus();
      }
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
      trigger?.focus();
    };
  }, [open]);

  return (
    <>
      <button ref={triggerRef} type="button" className="chart-card__action" onClick={() => setOpen(true)}>
        {label}
      </button>
      {open && createPortal(
        <div className="ceo-text-modal" role="presentation" onClick={() => setOpen(false)}>
          <div
            className="ceo-text-modal__dialog"
            role="dialog"
            aria-modal="true"
            aria-label={title}
            onClick={(event) => event.stopPropagation()}
          >
            <div className="ceo-text-modal__header">
              <button ref={closeRef} type="button" className="chart-card__action" onClick={() => setOpen(false)}>
                Sluiten
              </button>
            </div>
            <CeoTextPanel title={title} items={items} />
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
